import type { Dictionary } from '../dictionary.types'

const it: Dictionary = {
  ItemCountOfTotalCount: 'Elemento {{index}} di {{pagerCount}}',
  'Currently Active': 'Attualmente attivo',
}

export default it
